module.exports = __webpack_public_path__ + "img/p4-2-1.e737a99f.png";